import { Table_MasterData } from "../../../../Utils/AllPagesQuriesAndMutations";

const TableColumnManagementFields = [
  {
    name: "Table_Column_Management_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Table_Id",
        label: "Table Name",
        type: "InputDropForQuery",
        masterName: "Table_Master",
        dropdowncontent: Table_MasterData,
        max: Infinity,
        isRequired: true,
        autoFocus: true,
      },
      {
        id: Math.random() * 10,
        name: "Serial_No",
        label: "Serial No ",
        type: "number",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Field_Name",
        label: "Field Name",
        type: "text",
        min: 1,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Field_Label",
        label: "Field Lable",
        type: "text",
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Status",
        label: "Status",
        type: "checkbox",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Default",
        label: "Default",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Table_View",
        label: "Table View",
        type: "checkbox",
        min: 0,
        max: Infinity,
      },
    ],
  },
];

export { TableColumnManagementFields };
